import { render, staticRenderFns } from "./pagination-base.vue?vue&type=template&id=0809eb8c&scoped=true&"
import script from "./pagination-base.vue?vue&type=script&lang=ts&"
export * from "./pagination-base.vue?vue&type=script&lang=ts&"
import style0 from "./pagination-base.vue?vue&type=style&index=0&id=0809eb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809eb8c",
  null
  
)

export default component.exports